import React from "react";
import BaseOptions from "./BaseOptions";

export default class NumberFieldOptions extends BaseOptions {
  render() {
    return (
      <div>
        {this.renderTitle()}
        {this.renderRequiredOption()}
        {this.renderVisibilityOption()}
        {this.renderNumberRange()}
      </div>
    );
  }
}
